import { CustomButton } from '@/components/global/buttons/CustomButton.jsx';
import DeleteIcon from '@/assets/icons/delete-icon.svg?react';
import PropTypes from 'prop-types';

export const RemoveSubsetButton = ({ onRemove }) => (
    <CustomButton
        type='button'
        color='secondary'
        variant='contained'
        label='resources.parameter.labels.deleteSubset'
        startIcon={<DeleteIcon />}
        onClick={onRemove}
    />
);

RemoveSubsetButton.propTypes = {
    onRemove: PropTypes.func.isRequired,
};
